<script>
  import { seriesNumber } from "./store.js";
  export let organizeProductMaster;
  let promas = productMaster; //グローバル変数のproductMasterを代入

  /**
   * カード品番・商品名のみ抽出
   * productName {string}
   */
  const extractPartNumber = (productName) => {
    return productName.split(" ")[0];
  };

  const extractProductName = (productName) => {
    return productName.split(" ")[1];
  };

  /**
   * 商品情報一覧から買取強化カードのみを取り出す
   * @param productmaster {array}
   */
  const extractStrengthCards = (productmaster) => {
    let strengthCards = productmaster.filter((x) => {
      return x.PURCHASE_STRONG_PRODUCT.value.length > 0;
    });
    return strengthCards;
  };
</script>

{#await organizeProductMaster() then response}
  {#if extractStrengthCards(promas).length > 0}
    <h2><span>今回の買取り強化カード</span></h2>
    <ul class="pickup">
      {#each extractStrengthCards(promas) as data}
        <li>
          <div class="image">
            {#if data.IMAGE_PATH.value}
              <img
                src={data.IMAGE_PATH.value}
                alt={data.PRODUCT_NAME.value}
                loading="lazy"
              />
            {:else}
              <img
                src={`/images/dummy.png`}
                alt={data.PRODUCT_NAME.value}
                loading="lazy"
              />
            {/if}
          </div>
          <p class="price">
            ¥{Number(data.PURCHASE_PRICE.value).toLocaleString()}
          </p>
          <div class="title">
            <!-- <p class="code">{extractPartNumber(data.PRODUCT_NAME.value)}</p>
            <h3>{extractProductName(data.PRODUCT_NAME.value)}</h3> -->
            <p class="code">{data.ORGIN_CODE.value}</p>
            <h3>{data.PRODUCT_NAME.value}</h3>
          </div>
        </li>
      {/each}
    </ul>
  {/if}
{/await}
